import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { IConfigModel } from 'environments/environment.model';



if (environment.config.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

fetch('assets/setting.json')
  .then(response => response.json())
  .then((config: IConfigModel) => {

    if (config.production) {
      enableProdMode();
      if (window) { // to remove all console.log() in prod mode
        window.console.log = function () {
        };
      }
    }

    environment.config = config; // update environment

    const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

    bootstrap().catch(err => console.log(err));

  });

// if (environment.config.hmr) {
//   if (module['hot']) {
//     hmrBootstrap(module, bootstrap);
//   } else {
//     console.error('HMR is not enabled for webpack-dev-server!');
//     console.log('Are you using the --hmr flag for ng serve?');
//   }
// } else {
//   bootstrap().catch(err => console.log(err));
// }

